export default {
    prueba() {
        const peerConnection = new RTCPeerConnection(configuration);
        const dataChannel = peerConnection.createDataChannel();
    }
}